module.exports = __webpack_public_path__ + "img/page_img_2.fe7a00e1.png";